module.exports = __webpack_public_path__ + "static/media/1POLICY43.572786e8.jpg";